import { Tooltip } from 'antd';
import React from 'react';
import services from '../../services';
import SmallPie from '../tlelrik/SmallPie';



class RightTabLI extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            entity_row: {}
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.getEntityList()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date && prevProps.tab !== this.props.tab) {
            
            this.getEntityList()
        }
    }


    getEntityList = async () => {
        this.setState({
            entity_row: {}
        })
        let res = await services.EntityList.getEntityList('parcel', null, this.props.nif + '')
        if(res){
            this.setState({
                entity_row: res.entity_row
            })
        }

    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        if (this.props.tab === 'parcel') {
            window.localStorage.setItem('nif',this.props.nif)
            return (
                Object.keys(this.state.entity_row).length > 0 &&
                <li className="align-items-center border-0">
                    <span className="flex-auto-left">
                        <p className="m-0 text-left parcelholdername">{this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nome}</p>
                        <p className="small m-0 text-left parcelholdernumber">{this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nifap}</p>
                    </span>
                    <Tooltip title="Detalhes da entidade" color={"#333"}>
                        <span className="cursor-pointer" onClick={() => this.props.detailClick(this.state.entity_row && this.state.entity_row[this.props.nif])} data-toggle="modal" data-target='#left-detail-popup'>
                            <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
                        </span>
                    </Tooltip>
                </li>
            )
        } else if (this.props.tab === 'parcelProperty') {
            return (
                Object.keys(this.state.entity_row).length > 0 &&
                <li>
                    <SmallPie date={new Date()} fullPieData={this.props.paidata} data={this.props.row.quota} />
                    <span className="flex-auto-left">
                        <p className="m-0">{this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nome}</p>
                        <p className="small d-md-flex">
                            {this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nifap}
                            {
                                Object.keys(this.state.entity_row).includes(window.localStorage.getItem('nif')) &&
                                <p className="ml-2 titular-tag">TITULAR</p>
                            }
                        </p>
                    </span>
                    <Tooltip title="Detalhes da entidade" color={"#333"}>
                        <span className="cursor-pointer"><i className="fas fa-exclamation-circle ml-1" onClick={() => this.props.detailClick(this.state.entity_row && this.state.entity_row[this.props.nif])} data-toggle="modal" data-target='#left-detail-popup'></i></span>
                    </Tooltip>
                </li>
            )
        } else if (this.props.tab === 'parcelExplorer') {
            return (
                Object.keys(this.state.entity_row).length > 0 &&
                <li>
                    <SmallPie date={new Date()} fullPieData={this.props.paidata} data={this.props.row.quota}/>
                    <span className="flex-auto-left">
                        <p className="m-0">{this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nome}</p>
                        <p className="small d-md-flex">
                            {this.state.entity_row && this.state.entity_row[this.props.nif] && this.state.entity_row[this.props.nif].nifap}
                            {
                                Object.keys(this.state.entity_row).includes(window.localStorage.getItem('nif')) &&
                                <p className="ml-2 titular-tag">TITULAR</p>
                            }
                        </p>
                    </span>
                    <Tooltip title="Detalhes da entidade" color={"#333"}>
                        <span className="cursor-pointer"><i className="fas fa-exclamation-circle ml-1" onClick={() => this.props.detailClick(this.state.entity_row && this.state.entity_row[this.props.nif])} data-toggle="modal" data-target='#left-detail-popup'></i></span>
                    </Tooltip>
                </li>
            )
        }
    }
}

export default RightTabLI;